<div class="header">
  <h3>{{'SEARCH.TITLE' | translate}}</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="searchButtonClicked()" (clear)="clearSearch()"></app-filter-header>

  <div class="row row-eq-height">
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="company"
          [options]="company"
          [(ngModel)]="selectedCompany"
          (onChange)="filterBranchList()"
          [autoDisplayFirst]="false"
          placeholder="{{'FILTER.COMPANY' | translate}}"
          [style]="{'z-index': 3}"
        >
        </p-dropdown>
        <label for="company">{{'FILTER.COMPANY' | translate}}</label>
      </div>

      <div class="dropdown-label-group m-t-10 d-none">
        <p-dropdown
          class="dv-dropdown"
          selectId="companyBusiness"
          [options]="homeproGroup"
          [(ngModel)]="selectedHomeproGroup"
          [autoDisplayFirst]="false"
          placeholder="{{'FILTER.BUSINESS-TYPE' | translate}}"
        >
        </p-dropdown>
        <label for="companyBusiness">ประเภทธุรกิจ</label>
      </div>
    </div>
    <div class="col-md-4">
      <ng-select class="custom" [items]="newBuyerList"
                 id="receivedFrom"
                 bindLabel="name"
                 placeholder="{{'TABLE.CUSTOMER-NAME' | translate}}"
                 [(ngModel)]="selectedBranch"
                 [ngClass]="{'selected': searchBuyerName || searchingBuyerName}"
                  (focus)="searchingBuyerName = true" (blur)="searchingBuyerName = false">
      </ng-select>
      <label class="select-label" *ngIf="searchBuyerName || searchingBuyerName" for="receivedFrom">
        {{'TABLE.CUSTOMER-NAME' | translate}}
      </label>
    </div>

    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="documentType"
          [options]="rdDocumentType"
          [(ngModel)]="selectedRdDocumentType"
          [autoDisplayFirst]="false"
          placeholder="{{'FILTER.DOCUMENT-TYPE' | translate}}"
        >
        </p-dropdown>
        <label for="documentType">{{'FILTER.DOCUMENT-TYPE' | translate}}</label>
      </div>
    </div>

  </div>

  <div class="row row-eq-height m-t-10">
    <div class="col">
      <div class="form-label-group">
        <input class="form-control" type="text" id="searchText" [(ngModel)]="inputText"
               placeholder="{{'FILTER.DOCUMENT-NUMBER' | translate}}">
        <label for="searchText">{{'FILTER.DOCUMENT-NUMBER' | translate}}</label>
      </div>
    </div>

    <div class="col-md-4">
      <div class="dropdown" #dd="ngbDropdown" ngbDropdown placement="bottom-right" autoClose="outside">
        <div class="form-label-group">
          <input #ddi class="form-control" type="text" id="calendarDropdown" [value]="dateRange"
                 ngbDropdownToggle placeholder="{{'FILTER.DATE-OF-ISSUE' | translate}}" readonly>
          <label for="calendarDropdown">{{'FILTER.DATE-OF-ISSUE' | translate}}</label>
          <div class="calendar-trigger" (click)="$event.stopPropagation(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.SINCE' | translate}}</div>
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.UNTIL' | translate}}</div>
          </div>
          <div (click)="stopPropagation($event)">
            <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMinDate()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
            <p-calendar [(ngModel)]="endDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [minDate]="minDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
          </div>
        </div>
      </div>

      <div class="row align-items-center" style="height: 50%">
        <div class="col d-none">
          <p-checkbox class="dv-checkbox" [(ngModel)]="allBranch" binary="true"
                      (onChange)="selectAllBranch()"></p-checkbox>
          <!--<input type="checkbox" [(ngModel)]="allBranch" (change)="selectAllBranch()">-->
          <span>{{'COMMON.ALL-BRANCHES' | translate}}</span>
        </div>
      </div>
      <div class="row align-items-center" style="height: 50%;">
        <div class="col-md-auto d-none">
          <p-checkbox class="dv-checkbox" [(ngModel)]="allDocType" binary="true"
                      (onChange)="selectDocType()"></p-checkbox>
          <!--<input type="checkbox" [(ngModel)]="allDocType" (change)="selectDocType()">-->
          <span>{{'COMMON.ALL-TYPES-DOCUMENTS' | translate}}</span>
        </div>
      </div>
    </div>

  </div>

  <div class="row" *ngIf="errorMsg">
    <div class="col text-center text-red">
      {{ errorMsg }}
    </div>
  </div>
</div>

<div class="box-parent position-relative z-1">
  <app-custom-pagination
    [(currentPage)]="currentPage"
    [(itemsPerPage)]="itemsPerPage"
    [totalItems]="totalItems"
    [maxSize]="5"
    (pageChange)="pageChanged()"
    (optionChange)="searchButtonClicked()"
    *ngIf="loading === false && totalItems !== 0"
  >

    <!--<button type="button" class="btn btn-dv btn-clean btn-wide" (click)="selectAll()">เลือกทั้งหมด</button>-->
    <button type="button" class="btn btn-dv btn-wide" [disabled]="!EnabledDownloadSelected()"
            (click)="DownloadSelected(content2, 'xml')">
      {{'COMMON.DOWNLOAD' | translate}} XML
    </button>
    <button type="button" class="btn btn-dv btn-wide" [disabled]="!EnabledDownloadSelected()"
            (click)="DownloadSelected(content2, 'pdf')">
      {{'COMMON.DOWNLOAD' | translate}} PDF
    </button>
  </app-custom-pagination>

  <div class="row m-t-20" *ngIf="totalItems === 0 && loading === false">
    <div class="col-12 text-center">
      <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
    </div>
  </div>

  <div class="m-t-20 text-center ">
    <p-table #tt tableStyleClass="table" *ngIf="totalItems !== 0" [loading]="loading"
             [columns]="tableCol" [value]="tableData" [customSort]="true" (onSort)="sort($event)" [autoLayout]="true">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col">{{'COMMON.TABLE.ORDER' | translate}}</th>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" (click)="pageChanged()">
            {{col.header}}
            <!--<p-sortIcon [field]="col.field"></p-sortIcon>-->
          </th>
          <th scope="col">
            <p-checkbox class="dv-checkbox" binary="true" (onChange)="selectDeselectAll($event)"></p-checkbox>
          </th>
          <!--           <th scope="col">{{'COMMON.CANCEL' | translate}}</th>-->
          <th scope="col">{{'SEARCH.SEND-EMAIL' | translate}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td>{{index + 1 + ((currentPage - 1) * itemsPerPage)}}</td>
          <td>{{data.header_invoice_number}}</td>
          <td>{{data.header_issue_dt | date:"dd/MM/yyyy"}}</td>
          <td>{{data.buyer_name + "/" + data.buyer_branch_code}}</td>
          <td>{{data.rd_document_type_display}}</td>
          <td>{{data.total_items_line_total_amount_after_discount.toLocaleString()}}</td>
          <td>{{data.total_items_vat.toLocaleString()}}</td>
          <td>{{data.total_items_total_payment.toLocaleString()}}</td>
          <td style="text-align: center">
            <p-checkbox *ngIf="data.status =='active'" class="dv-checkbox" binary="true"
                        [(ngModel)]="selectedValues[index]"></p-checkbox>
          </td>
          <!-- <td>
            <button *ngIf="data.status == 'active' " (click)="openCancelModal($event, cancelPopup, data,index)" class="btn btn-dv btn-wide">{{'TEXT.CANCEL'| translate}}</button>
            <i *ngIf="data.status == 'cancelled' " class="fa fa-exclamation" aria-hidden="true"></i>
          </td> -->
          <td>
            <button [disabled]="data.status == 'cancelled' " class="btn btn-dv btn-wide"
                    (click)="openMailModal($event, modalSendEmail, index)">
              <i class="fas fa-envelope m-r-5"></i>
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
</div>

<ng-template #content2 let-modal>
  <div class="modal-header">
    <!-- <h4 class="modal-title" id="modal-basic-title">Alert</h4> -->
    <button type="button" class="close" aria-label="Close" [disabled]="loading_all_zip" (click)="closeDownloadAll()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row" style="margin-bottom: 10px">
      <div *ngIf="loading_all_zip" class="col-12 text-center">
        <i class="fa fa-spinner fa-2x fa-spin" style="margin-left:5px"></i>
        <br/>
        {{allZipCurrent}} / {{allZipCount}}
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <ngb-progressbar *ngIf="loading_all_zip === true" type="info" [value]="loading_all_zip_progress"
                         height="20px"></ngb-progressbar>
        <span *ngIf="loading_all_zip === false" style="color: #4d5f7a">{{loading_all_zip_message}}</span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-dv btn-danger btn-wide"
            (click)="closeDownloadAll()">{{'COMMON.CLOSE' | translate}}</button>
  </div>
</ng-template>

<ng-template #modalSendEmail let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{'SEARCH.SEND-EMAIL' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeMailModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div>
      <label for="email">{{'SEARCH.FILL-EMAIL' | translate}}:</label>
      <input class="form-control" type="text" id="email" [(ngModel)]="modalData.latest_sent_email">
    </div>
    <div class="m-t-15">
      <label for="email">{{'SEARCH.FILL-BROKER-EMAIL' | translate}}:</label>
      <input class="form-control" type="text" id="email" [(ngModel)]="modalData.latest_sent_broker_email">
    </div>

    <div *ngIf="modalData.status_send_email !== 'not_yet_sent' && modalData.email_sent_msg" class="text-center">
      <b style="color:#ff002c;" *ngIf="modalData.status_send_email === 'failed'">
        <div>{{ modalData.email_sent_msg }}</div>
        <div>{{'SEARCH.EMAIL-ERROR' | translate}}</div>
      </b>
      <b *ngIf="modalData.status_send_email === 'sent'">
        <div>{{ modalData.email_sent_msg }}</div>
      </b>
    </div>
  </div>

  <div class="modal-footer">
    <div class="col-6 text-left">
      <button type="button" class="btn btn-dv btn-danger btn-wide" (click)="closeMailModal()">
        {{'SEARCH.CANCEL' | translate}}
      </button>
    </div>
    <div class="col-6 text-right p-0">
      <button type="button" *ngIf="modalData.status_send_email !== 'sent' || !modalData.email_sent_msg"
        class="btn btn-dv btn-wide" [disabled]="isSending" (click)="sendMail()">
        <i *ngIf="isSending" class="fa fa-spinner fa-spin m-r-5"></i>
        {{ isSending ? ('SEARCH.SENDING' | translate) : ('SEARCH.SEND' | translate) }}
      </button>

      <button *ngIf="modalData.status_send_email === 'sent' && modalData.email_sent_msg" type="button"
              class="btn btn-dv btn-wide" (click)="closeMailModal()">
        {{'COMMON.OK' | translate}}
      </button>
    </div>
  </div>
</ng-template>

<!-------------------------modal cancel popup------------------------------------------->
<ng-template #cancelPopup let-modal>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="closeCancelModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body bg-model">
    <div class="row bg-model">
      <div class="col-12 text-center bg-model">
        <table>
          <thead>
          <tr>
            <th scope="col" width="30%">{{ 'TEXT.CANCEL-POPUP' | translate }}</th>
          </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="col-6 text-right p-0">
      <button type="button" class="btn btn-dv btn-wide" (click)="cancelInvoice()">
        {{ 'TEXT.YES' | translate }}
      </button>
    </div>
    <div class="col-6 text-left">
      <button type="button" class="btn btn-dv btn-wide" style="background-color: grey" (click)="closeCancelModal()">
        {{ 'TEXT.NO' | translate }}
      </button>
    </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/search/search.component.html